<style lang="scss">
    .c-header {
      height: 100%;
      .c-header-left {
        float: left;
      }
      .c-header-logo {
        display: inline-block;
        margin: 10px 10px 0 10px;
        color: #fff;
        vertical-align: middle;
      }
      .c-header-icon {
        display: inline-block;
        font-size: 36px;
        vertical-align: middle;
      }
      .c-header-title {
        display: inline-block;
        margin-left: 5px;
        font-size: 22px;
        vertical-align: middle
      }
      .c-header-collage {
        display: inline-block;
        margin: 12px 15px 0 0;
        padding: 6px 10px;
        vertical-align: middle;
        color: #fff;
        i {
          font-size: 22px;
        }
      }
      .c-header-collage:hover {
        background: $c-bgHoverColor;
      }
      .c-header-user {
        margin: 10px 10px 0 0;
        float: right;
        .el-button {
          padding: 10px;
        }
        .el-button--primary {
          background: $c-bgColor;
          border-color: $c-bgColor;
        }
        .el-button--primary:hover {
          background: $c-bgHoverColor;
        }
      }
      .c-header-area {
        margin: 10px 10px 0 0;
        float: right;
        .el-button {
          padding: 10px;
        }
        .el-button--primary {
          background: $c-bgHoverColor !important;
          border-color: $c-bgHoverColor !important;
        }
        .el-button--primary:hover {
          background: $c-bgHoverColor;
        }
      }
      .c-hearder-btn {
        float: right;
        margin: 15px 10px 0 0;
        padding: 4px;
        font-size: 16px;
        background: rgba(255, 255, 255, 0.2);
      }
      .c-skin-color {
        display: block;
        margin: 10px 10%;
        width: 80%;
        height: 40px;
        line-height: 40px;
        border-radius: 6px;
        color: #fff;
        text-align: center;
      }
      .c-server-drawer {
        padding: 15px;
        max-width: 480px;
        min-width: 320px;
        height: 100% !important;
        overflow: hidden;
        .el-drawer__header {
          margin-bottom: 12px;
          padding: 0;
        }
        .el-drawer__body {
          height: 100%;
          overflow: hidden;
          .el-scrollbar {
            height: 100%;
            overflow: hidden;
            .el-scrollbar__wrap {
              overflow-x: hidden;
              overflow-y: scroll;
            }
          }
        }
        .c-server-name {
          margin: 0 0 15px;
          padding: 12px;
          width: 100%;
        }
      }
    }
</style>

<template>
    <div class="c-header">
        <div class="c-header-left">
          <a href="/" class="c-header-logo" v-if="$store.getters.device === 'pc'">
              <i class="c-header-icon el-icon-place"></i>
              <span class="c-header-title">{{ getSiteName }}</span>
          </a>
          <a href="javascript:void(0)" class="c-header-collage" @click="setCollapse">
              <i class="el-icon-s-unfold" v-if="$store.getters.collapse"></i>
              <i class="el-icon-s-fold" v-else></i>
          </a>
        </div>
        <header-bar v-if="false"></header-bar>
        <el-dropdown class="c-header-user" trigger="click">
          <el-button type="primary">
              <i class="el-icon-s-custom"></i>
              {{ this.$store.getters.name }}
              <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="_updatePassword()"><i class="el-icon-lock"></i> 修改密码</el-dropdown-item>
              <el-dropdown-item @click.native="loginOut"><i class="el-icon-switch-button"></i> 退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <template v-if="$store.getters.device === 'pc'">
          <el-button type="primary" class="c-hearder-btn" title="切换皮肤" @click="showSkinPanel(true)"><i class="el-icon-s-flag"></i></el-button>
          <el-button type="primary" class="c-hearder-btn" title="全屏显示" @click="fullScreen()"><i class="fa fa-arrows-alt"></i></el-button>
        </template>
        <!--皮肤-->
        <el-drawer title="切换皮肤" :with-header="false" :visible.sync="showSkinTool">
          <el-row :gutter="10">
            <el-col :span="12" v-for="(name, index) in skinThemeNames" :key="name">
              <a href="javascript:void(0)" class="c-skin-color" :style="'background: #' + name" @click="getSkinName(index)">{{ '#' + name }}</a>
            </el-col>
          </el-row>
        </el-drawer>
        <!--服务区选择-->
        <template v-if="allServiceAreas.length > 5">
          <span class="c-header-area">
            <el-button type="primary" @click="showServerDrawer(true)">
                {{ $store.getters.serviceArea }}
                <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
          </span>
          <el-drawer custom-class="c-server-drawer" title="选择服务区" size="50%" :visible.sync="isShowServerDrawer">
            <el-scrollbar ref="refDrawerScrollbar">
              <el-row :gutter="10">
                <el-col :span="12" v-for="area in allServiceAreas" :key="area.id">
                  <el-tooltip v-if="!area.isActive" content="小安系统已停用" placement="bottom-start">
                    <el-button type="info" class="c-server-name" :plain="area.name !== $store.getters.serviceArea"
                      @click="switchArea(area)">{{ area.name }}</el-button>
                  </el-tooltip>
                  <el-button type="primary" class="c-server-name" v-else
                    :plain="area.name !== $store.getters.serviceArea"
                      @click="switchArea(area)">{{ area.name }}</el-button>
                </el-col>
              </el-row>
            </el-scrollbar>
          </el-drawer>
        </template>
        <el-dropdown class="c-header-user c-header-area" trigger="click" v-else>
          <el-button type="primary">
              {{ this.$store.getters.serviceArea }}
              <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
              <el-dropdown-item style="min-width: 50px" v-for="area in allServiceAreas" :key="area.id" @click.native="switchArea(area)">
                <span class="col_danger" v-if="!area.isActive">[已停用] </span>{{ area.name }}
              </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!--修改密码-->
        <password :ref="refPassword"></password>
    </div>
</template>

<script>
import configMixins from "@/mixins/config"
import HeaderBar from '../components/HeaderBar'
import { validPassword } from '@/utils/validate'
import skinTheme from '@/mixins/skinTheme'
import password from '../components/Password'
export default {
    name: "headers",
    components: {
      HeaderBar,
      password
    },
    mixins: [configMixins, skinTheme],
    data() {
      return {
        showSkinTool: false,
        isShowServerDrawer: false,
        refPassword: "refHeadersToPassword"
      }
    },
    created() {
      
    },
    watch: {
        "$store.getters.serviceAreas": {
          handler() {
            this.setDefaultArea()
          },
          deep: true
        }
    },
    computed: {
      getSiteName() {
        return this.$store && this.$store.getters && this.$store.getters.systemConfig 
               && this.$store.getters.systemConfig.systemName
      },
      allServiceAreas() {
        let areas = this.$store.getters.serviceAreas
        // 根据enableSpider是否为true来排序到前面
        return areas.sort((a, b) => {
          if (a.enableSpider && !b.enableSpider) {
            return -1
          } else if (!a.enableSpider && b.enableSpider) {
            return 1
          } else {
            return 0
          }
        })
      }
    },
    mounted() {
      // 获取皮肤
      this.getSkinByState()
      // 默认设置第一个服务区
      this.setDefaultArea()
    },
    methods: {
      setDefaultArea() {
        if (!this.$store.getters.serviceArea || !this.$store.getters.servicePlatform || this.allServiceAreas.findIndex(x => x.name === this.$store.getters.serviceArea) === -1) {
          this.switchArea(this.allServiceAreas[0])
        }
      },
      setCollapse() {
        this.$store.dispatch('setCollapse')
      },
      _updatePassword() {
        this.$refs[this.refPassword].showDialog = true
      },
      loginOut() {
        this.confirm("确定要退出登录？").then(() => {
          this.$store.dispatch('loginOut').then(() => {
            location.reload()
            // this.$router.push({ path: '/login' })
          })
        })
      },
      // 切换皮肤
      showSkinPanel(state) {
        this.showSkinTool = state || false
      },
      // 获取皮肤颜色并切换
      getSkinName(index) {
        this.changeSkin(index, () => {
          this.showSkinPanel()
        })
      },
      // 执行全屏操作
      fullScreen() {
        if (this.fullScreenEnble()) {
          let element = document.documentElement;
          if (this.fullScreenElement()) {
            if (document.exitFullscreen) {
              document.exitFullscreen()
            } else if (document.webkitCancelFullScreen) {
              document.webkitCancelFullScreen()
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen()
            } else if (document.msExitFullscreen) {
              document.msExitFullscreen()
            }
          } else {
            if (element.requestFullscreen) {
              element.requestFullscreen()
            } else if (element.webkitRequestFullScreen) {
              element.webkitRequestFullScreen()
            } else if (element.mozRequestFullScreen) {
              element.mozRequestFullScreen()
            } else if (element.msRequestFullscreen) {
              // IE11
              element.msRequestFullscreen()
            }
          }
        }
      },
      // 返回可以处于全屏的元素
      fullScreenElement() {
        // 要在用户授权全屏后才能获取全屏的元素，否则 fullscreenEle为null
        let fullscreenEle = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement
        return fullscreenEle
      },
      // 是否可以请求全屏的状态
      fullScreenEnble() {
        // 要在用户授权全屏后才能准确获取当前的状态
        let isFullscreen = document.fullscreenEnabled || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled
        return isFullscreen
      },
      showServerDrawer(state) {
        this.isShowServerDrawer = state || false
      },
      switchArea(item) {
        this.$store.dispatch('setServiceArea', item && item.name || "")
        this.$store.dispatch('setServicePlatform', item && item.platform || "")
        this.showServerDrawer(false)
      }
    }
}
</script>